<script setup lang="ts">
import CartItemDeleteButton from './CartItemDeleteButton.vue';
import CartItemProductInfo from './CartItemProductInfo.vue';

defineProps<{
  productId: string;
  imageUrl: string | null;
  productName: string;
  dateTime: string;
  personCount: number;
  isDeleting: boolean;
  disabled: boolean;
}>();

const emit = defineEmits<{
  delete: [];
}>();
</script>

<template>
  <div class="expired-overlay">
    <div class="hold">
      <span class="expired-badge">{{ $t('cart.details.expired') }}</span>
      <CartItemDeleteButton
        :is-deleting="isDeleting"
        :disabled="disabled"
        @delete="emit('delete')"
      />
    </div>

    <CartItemProductInfo
      :product-id="productId"
      :image-url="imageUrl"
      :product-name="productName"
      :date-time="dateTime"
      :person-count="personCount"
      :is-expired="true"
    />

    <p class="expired-description">
      {{ $t('cart.details.expiredDescription') }}
    </p>
  </div>
</template>

<style scoped lang="css">
.hold {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.expired-overlay :deep(.product-informations) {
  opacity: 0.55;
}

.expired-description {
  opacity: 0.55;
  font-size: var(--yb-text-sm);
  color: #92400e;
  margin: 0;
}

.expired-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  background: #fef3c7;
  color: #92400e;
  border-radius: var(--yb-radius-xs);
  font-size: var(--yb-text-sm);
  font-weight: var(--yb-text-semi-bold);
}
</style>
